import {TermTooltipLazy} from 'app/modules/termTooltip/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineTermTooltip(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-term-tooltip')) {
        return;
    }

    customElements.define(
        'gem-term-tooltip',
        class extends WebComponentLoader {
            reactLazyComponent = TermTooltipLazy;
            removePortalContent = false;
            hasConfig = false;
        },
    );
}
